import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CheckSquareSvg = function CheckSquareSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.931 16.737 6.033-7.54-1.09-.872-5.13 6.413-2.709-2.321-.908 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 2.249H2v20h20zM3.395 20.854V3.644h17.21v17.21z",
    clipRule: "evenodd"
  }));
};
export var CheckSquare = function CheckSquare(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CheckSquareSvg
  }));
};